/**
 * TimeframeSelector Component
 *
 * Pill button group for selecting chart timeframe
 */

import type { TimeframeOption } from './types';
import styles from './TimelineChart.module.css';

interface TimeframeSelectorProps {
  value: TimeframeOption;
  onChange: (timeframe: TimeframeOption) => void;
}

const TIMEFRAME_OPTIONS: TimeframeOption[] = ['6M', '1Y', '2Y', '3Y', 'MAX'];

export default function TimeframeSelector({
  value,
  onChange,
}: TimeframeSelectorProps) {
  return (
    <div className={styles.timeframeSelector} role="group" aria-label="Timeframe selector">
      {TIMEFRAME_OPTIONS.map((option) => (
        <button
          key={option}
          type="button"
          className={`${styles.timeframeBtn} ${value === option ? styles.active : ''}`}
          onClick={() => onChange(option)}
          aria-pressed={value === option}
        >
          {option}
        </button>
      ))}
    </div>
  );
}
